import { useQuery, useQueryClient } from '@tanstack/react-query';

import type { GetResponse } from '@tf/api';
import { gql, GraphQLClient } from '@tf/api';
import type { IdenfyResponse } from '@tf/shared';
import { objectUriByNodeIdQueryOptions } from '@tf/shared';
import type { ObjectRelation } from '@tf/utils';

import type { CheckState } from './idenfyUtils';

// TODO: copied from apps/tf. Move to shared?

export type LivenessCheck = {
	id: string;
	meta: {
		service_kind: 'idenfy';
		state: CheckState;
	};
	data: {
		media?: ObjectRelation<'record_attachment'>[];
		response?: IdenfyResponse;
	};
	attachments: {
		object: {
			id: string;
			meta: {
				'@createdAt': string;
				'@filename': string;
			};
		};
	}[];
};

export const useUnitLivenessChecks = (unitNodeId: number) => {
	const queryClient = useQueryClient();

	return useQuery({
		queryKey: ['unitLivenessChecks', unitNodeId],
		queryFn: async (): Promise<LivenessCheck[]> => {
			const unitObjectId = await queryClient.fetchQuery(objectUriByNodeIdQueryOptions(unitNodeId));

			const res = await GraphQLClient.getInstance().request<
				GetResponse<LivenessCheck>,
				{ unitObjectId: string }
			>(
				gql`
					query UnitLivenessChecks($unitObjectId: JSON!) {
						get(
							rootFilter: {
								kind: "liveness_check"
								meta: { AND: [{ key: "/@with/unit", operator: EQ, value: $unitObjectId }] }
							}
							paginationFilter: {
								limit: 10
								offset: 0
								sortByMeta: "/@createdAt"
								sortByDirection: DESC
							}
						) {
							id
							meta(path: ["/service_kind", "/state"])
							data(path: ["/media", "/response"])
							attachments: nestedRelation(filter: { relationKind: "record_attachment" }) {
								object {
									id
									meta
								}
							}
						}
					}
				`,
				{ unitObjectId }
			);

			return res.get;
		},
	});
};
